import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type {
  MarkTicketCommentAsSeenInput,
  MarkTicketCommentAsSeenMutation,
  MarkTicketCommentAsSeenMutationVariables,
} from '@/shared/api';
import MARK_TICKET_COMMENT_AS_SEEN from '../mutations/markTicketCommentAsSeen';

/**
 * Marks the comments of a clinic support ticket as seen by the current user. Runs the MARK_TICKET_COMMENT_AS_SEEN mutation with the given input and passes the result through the shared error unwrapper, which throws when the backend reports a failure.
 *
 * @param input - Mutation input identifying the ticket comments to mark as seen.
 * @returns Promise resolving once the mutation has been acknowledged.
 */
const handleMarkTicketCommentAsSeen = async (input: MarkTicketCommentAsSeenInput) => {
  const client = createClient();
  const result = await client.mutate<
    MarkTicketCommentAsSeenMutation,
    MarkTicketCommentAsSeenMutationVariables
  >({
    mutation: MARK_TICKET_COMMENT_AS_SEEN,
    variables: {
      input,
    },
  });
  handleErrorApi(result, 'markTicketCommentAsSeen');
};

export default handleMarkTicketCommentAsSeen;
